module.exports = __webpack_public_path__ + "img/default.848c0e1a.png";